// @flow
import React from 'react';
import dataFormat from 'date-fns/format';
import { imageURL, numberWithCommas, orderShippingStatus } from "lib/common";
import Button from 'components/common/Button';
import { camelCase } from 'lodash';
import './OrderListTemplate.scss';

type Props = {
  orders: any,
  onClick: any,
  downloadRequestsExcel: any,
  downloadInventoriesExcel: any,
};

const statusTrans = key => {
  let words = {
    statusPlaced: '결제 대기',
    statusCancelledByStore: '운영자 취소',
    statusCancelledByCustomer: '고객 취소',
    statusPaid: '결제 완료',
    statusUnderPaid: '부분 결제',
    statusOverPaid: '초과 결제',
    statusRefunded: '환불 완료',
    statusPartiallyRefunded: '부분 환불 완료',
    statusUnderRefunded: '환불 처리 중',
    statusOverRefunded: '초과 환불',
    shippingStatusPending: '배송 대기',
    shippingStatusShipped: '배송중',
    shippingStatusArrived: '배송 완료',
    shippingStatusReceived: '수령 완료',
  };
  return words[key];
};

const OrderListTemplate = (props: Props) => (
  <div className="OrderListTemplate">
    <div className="order-list">
      <div className="order-header">
        <h2>주문 목록</h2>
        <div className="order-export-btn">
          <Button theme="default" color="green" onClick={props.downloadRequestsExcel}>
            구매관리 엑셀
          </Button>
          <Button theme="default" color="green" onClick={props.downloadInventoriesExcel}>
            재고관리 엑셀
          </Button>
        </div>
      </div>
      <table className="table orders">
        <thead>
          <tr>
            <th>주문 번호</th>
            <th colSpan="2">구매 상품 정보</th>
            <th>주문 금액</th>
            <th>주문 일시</th>
            <th>거래명세서</th>
          </tr>
        </thead>
        <tbody>
          {props.orders.items.length === 0 ? (
            <tr className="cart-has-no-items">
              <td colSpan="5">
                <p>주문 목록에 주문이 하나도 없습니다.</p>
              </td>
            </tr>
          ) : (
            props.orders.items.map((order, index) => (
              <tr className="order" key={order.id}>
                <td>
                  <span className="order-id" onClick={() => props.onClick(`/orders/${order.id}`)}>
                    {order.id}
                  </span>
                  <span className="tag order-status" data-status={order.status}>
                    {order.status === 'cancelled'
                      ? statusTrans(camelCase(['status', order.status, 'by', order.cancellation.by]))
                      : statusTrans(camelCase(['status', order.status]))}
                  </span>
                  {orderShippingStatus(order) && (
                    <span
                      className="tag order-shipping-status"
                      data-status={orderShippingStatus(order)}
                    >
                      {statusTrans(camelCase(['shippingStatus', orderShippingStatus(order)]))}
                    </span>
                  )}
                </td>
                <td>
                  <span
                    className="order-thumbnail"
                    onClick={() => props.onClick(`/orders/${order.id}`)}
                  >
                    <img
                      src={imageURL(order.items[0].product.thumbnail, 120, 120)}
                      alt="thumbnail"
                    />
                  </span>
                </td>
                <td>
                  <span
                    className="order-first-item"
                    onClick={() => props.onClick(`/orders/${order.id}`)}
                  >
                    {order.items[0].product.name}
                  </span>
                  {order.items.length > 1 && (
                    <span
                      className="order-rest-items"
                      onClick={() => props.onClick(`/orders/${order.id}`)}
                    >
                      {`외 ${order.items.length - 1}개의 상품`}
                    </span>
                  )}
                </td>
                <td>
                  <span className="order-total">{numberWithCommas(order.total.amount.raw)}원</span>
                </td>
                <td>
                  <span className="order-created-at">{dataFormat(order.created_at, 'YYYY년 M월 D일 HH시 mm분')}</span>
                </td>
                <td>
                  {
                    <span className="order-created-at">
                      <Button theme="outline" to={`/orders/${order.id}/invoice`}>
                        거래명세서
                      </Button>
                    </span>
                  }
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </div>
);

export default OrderListTemplate;



// WEBPACK FOOTER //
// ./src/components/order/OrderListTemplate/OrderListTemplate.js